import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function StylesProvider({ children }) {
  return (
    <>
      {children}
      <style global jsx>{`
        // Desktop Only
        @media (min-width: ${viewport.tablet.sm}) {
        }

        // RWD
        @media (max-width: ${viewport.tablet.sm}) {
          .faq-section .faq-ques {
            font-size: ${font.size.md[3]};
          }
        }
      `}</style>
    </>
  );
}
